import { createGlobalStyle } from 'styled-components'

import background from '../assets/img/FlagBG.png'
import backgroundMobile from '../assets/img/FlagBGMobile.png'

export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
  }

  html {
    width: 100vw;
    height: 100vh;

    color: #fff;

    background-image: url(${background});
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-size: cover;

    @media screen and (max-width: 812px) {
      background-image: url(${backgroundMobile});
    }
  }

  #App {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    height: 100vh;
    align-content: space-between;
    
    @media screen and (max-width: 812px) {
      flex-direction: row;
      min-height: 100vh;
      height: unset;
    }
  }
`